// dependencies
import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { View } from "react-native";
import { ProgressBar } from "react-native-web";

// components
import Button from "@cloudspire/legacy-resources/src/components/Button2";
import Stack from "@cloudspire/legacy-resources/src/components/Stack";
import Text from "@cloudspire/legacy-resources/src/components/Text";

// constants
import theming from "@cloudspire/legacy-resources/src/constants/theming";

// libraries
import { emToPx } from "@cloudspire/legacy-resources/src/libraries";
import { lighten } from "@cloudspire/legacy-shared/src/libraries";

const { useTheme } = theming;

function Pagination(props) {
  const { roomsResponse, total, perPage, onPressSeeMore } = props;

  const resultCount = (roomsResponse.data?.roomList ?? []).length;

  const intl = useIntl();

  const theme = useTheme();

  const handlePressSeeMore = useCallback(
    function (event) {
      event.preventDefault();

      onPressSeeMore();
    },
    [onPressSeeMore]
  );

  const loading =
    (!roomsResponse.error && !roomsResponse.data) ||
    (roomsResponse.size > 1 && resultCount < roomsResponse.size * perPage);

  return (
    <View
      style={{ maxWidth: emToPx(30), marginLeft: "auto", marginRight: "auto" }}
    >
      <View>
        <Text>
          {intl.formatMessage(
            {
              defaultMessage:
                "Il vous reste {roomCount, plural, =1 {un hébergement} other {# hébergements}} à découvrir",
            },
            {
              roomCount: total - resultCount,
            }
          )}
        </Text>

        <Stack marginTop={1} />

        <ProgressBar
          color={theme.PRIMARY_COLOR}
          trackColor={lighten(theme.PRIMARY_COLOR, 120)}
          progress={resultCount / total}
        />
      </View>
      <Stack marginTop={1} />
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <Button
          appearance="secondary"
          disabled={loading}
          label={
            loading
              ? intl.formatMessage({
                  defaultMessage: "Chargement des hébergements",
                })
              : intl.formatMessage({
                  defaultMessage: "Plus d’hébergements",
                })
          }
          onPress={handlePressSeeMore}
        />
      </View>
    </View>
  );
}

export default Pagination;
